webpackJsonp([182939616564507,4937948545974,64667267319313,78049113020613,189425480476032,130732907663140],{

/***/ 657:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = Assets;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactResponsive = __webpack_require__(18);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _HeadingBlock = __webpack_require__(13);
	
	var _HeadingBlock2 = _interopRequireDefault(_HeadingBlock);
	
	var _MediaThreeColImages = __webpack_require__(208);
	
	var _MediaThreeColImages2 = _interopRequireDefault(_MediaThreeColImages);
	
	var _assets = __webpack_require__(121);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Assets() {
	  return _react2.default.createElement(
	    _spacing2.default,
	    { type: 'padding', size: 'xl', position: 'top' },
	    _react2.default.createElement(
	      _spacing2.default,
	      { type: 'padding', sizeM: 'xl', position: 'topBottom' },
	      _react2.default.createElement(
	        _pageWrap2.default,
	        { size: 'l' },
	        _react2.default.createElement(
	          _spacing2.default,
	          { type: 'padding', size: 'xl', position: 'bottom' },
	          _react2.default.createElement(
	            _reactResponsive2.default,
	            { maxWidth: 769 },
	            _react2.default.createElement(_Image2.default, _extends({}, _assets2.default.assetsFallback, { hasShadow: false }))
	          ),
	          _react2.default.createElement(_HeadingBlock2.default, {
	            size: 'xs',
	            justifyContent: 'center',
	            justifyM: 'start',
	            title: 'Instantly turn designs into code, specs and assets',
	            copy: _react2.default.createElement(
	              'span',
	              null,
	              'Our design handoff tool, puts an end to manual design documentation, PDFs and redlines. Now, all you need for designer developer handoff is a single URL, where they can find everything they need to start building.',
	              _react2.default.createElement('br', null),
	              _react2.default.createElement('br', null),
	              'Handoff generates CSS, Swift and Android XML instantly for designs made within Marvel or Sketch, shaving time off the design to development process.'
	            )
	          })
	        )
	      ),
	      _react2.default.createElement(
	        _reactResponsive2.default,
	        { minWidth: 770 },
	        _react2.default.createElement(_MediaThreeColImages2.default, {
	          radius: 'none',
	          images: _assets2.default.assetsBlock,
	          fallbackImage: _assets2.default.assetsFallback
	        })
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 658:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = Code;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactResponsive = __webpack_require__(18);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _grid = __webpack_require__(5);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _HeadingBlock = __webpack_require__(13);
	
	var _HeadingBlock2 = _interopRequireDefault(_HeadingBlock);
	
	var _MediaMultipleImages = __webpack_require__(30);
	
	var _MediaMultipleImages2 = _interopRequireDefault(_MediaMultipleImages);
	
	var _ParallaxWrapper = __webpack_require__(28);
	
	var _ParallaxWrapper2 = _interopRequireDefault(_ParallaxWrapper);
	
	var _Pattern = __webpack_require__(31);
	
	var _Pattern2 = _interopRequireDefault(_Pattern);
	
	var _Shape = __webpack_require__(27);
	
	var _Shape2 = _interopRequireDefault(_Shape);
	
	var _assets = __webpack_require__(121);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Code() {
	  return _react2.default.createElement(
	    _pageWrap2.default,
	    { size: 'l' },
	    _react2.default.createElement(
	      _spacing2.default,
	      { size: 'xl', type: 'padding', position: 'topBottom' },
	      _react2.default.createElement(
	        _grid2.default,
	        { columns: 12 },
	        _react2.default.createElement(
	          _grid.GridItem,
	          { columnSpan: 12, columnSpanM: 6, alignContent: 'center' },
	          _react2.default.createElement(
	            _reactResponsive2.default,
	            { minWidth: 770 },
	            _react2.default.createElement(_HeadingBlock2.default, {
	              justifyContent: 'center',
	              maxWidth: 430,
	              title: 'Export code as CSS, Swift and Android XML',
	              copy: _react2.default.createElement(
	                'span',
	                null,
	                'Whether you\'ve designed mockups in Sketch or within the Marvel design tool, you can generate the code you need to take a prototype from design to development.',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                'With one click, you can download assets and copy the CSS, Swift and Android XML code for your prototype - simplifying your entire design developer handoff process.'
	              )
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _grid.GridItem,
	          { columnSpan: 12, columnSpanM: 6, alignContent: 'center' },
	          _react2.default.createElement(
	            _MediaMultipleImages2.default,
	            {
	              fallbackImageAlt: _assets2.default.cssFallback.alt,
	              fallbackImageSrc: _assets2.default.cssFallback.src,
	              fallbackImageMaxWidth: _assets2.default.cssFallback.maxWidth
	            },
	            _react2.default.createElement(
	              _ParallaxWrapper2.default,
	              null,
	              _react2.default.createElement(_Shape2.default, { type: 'square', color: 'lightGreen', top: '35%', left: '20%' }),
	              _react2.default.createElement(_Pattern2.default, { type: 'fish', color: 'green', top: '70%', left: '36%' })
	            ),
	            _react2.default.createElement(
	              _ParallaxWrapper2.default,
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'opacity-50' },
	                _react2.default.createElement(_Image2.default, _extends({}, _assets2.default.backPanel, {
	                  hasShadow: false,
	                  left: '15%',
	                  top: '5%',
	                  maxWidth: 242,
	                  position: 'absolute'
	                }))
	              )
	            ),
	            _react2.default.createElement(
	              _ParallaxWrapper2.default,
	              { speed: 1.2 },
	              _react2.default.createElement(_Image2.default, _extends({}, _assets2.default.designWatch, {
	                maxWidth: 240,
	                position: 'absolute',
	                top: '32%',
	                left: '5%',
	                borderRadius: 'm'
	              }))
	            ),
	            _react2.default.createElement(
	              _ParallaxWrapper2.default,
	              { speed: 2 },
	              _react2.default.createElement(_Image2.default, _extends({}, _assets2.default.cssPanel, {
	                borderRadius: 'm',
	                left: '32%',
	                maxWidth: 300,
	                position: 'absolute',
	                top: '20%'
	              }))
	            )
	          ),
	          _react2.default.createElement(
	            _reactResponsive2.default,
	            { maxWidth: 769 },
	            _react2.default.createElement(
	              _spacing2.default,
	              { size: 'l', type: 'margin', position: 'top' },
	              _react2.default.createElement(_HeadingBlock2.default, {
	                justifyContent: 'center',
	                maxWidth: 430,
	                title: 'CSS, Swift and Android XML code',
	                copy: 'Grab the measurements, typography and colours in one click. Your developers will love how easy this is.'
	              })
	            )
	          )
	        )
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 659:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = CtaBlock;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _CtaDefault = __webpack_require__(61);
	
	var _CtaDefault2 = _interopRequireDefault(_CtaDefault);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var buttons = [{
	  text: 'Get started for free',
	  link: '/signup/',
	  styles: {
	    shape: 'rounded',
	    size: 'large',
	    minWidth: 160
	  }
	}, {
	  text: 'View plans',
	  link: '/pricing/',
	  styles: {
	    shape: 'rounded',
	    size: 'large',
	    kind: 'ghost',
	    minWidth: 160
	  }
	}];
	
	function CtaBlock() {
	  return _react2.default.createElement(
	    _spacing2.default,
	    { type: 'padding', size: 'm', position: 'topBottom' },
	    _react2.default.createElement(_CtaDefault2.default, {
	      maxWidth: 480,
	      title: 'Join thousands of developers working smarter with Handoff. Get started for free.',
	      buttons: buttons
	    })
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 660:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = Design;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _HeadingBlock = __webpack_require__(13);
	
	var _HeadingBlock2 = _interopRequireDefault(_HeadingBlock);
	
	var _MediaFeature = __webpack_require__(68);
	
	var _MediaFeature2 = _interopRequireDefault(_MediaFeature);
	
	var _assets = __webpack_require__(121);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Design(_ref) {
	  var color = _ref.color;
	
	  return _react2.default.createElement(
	    _spacing2.default,
	    { type: 'padding', size: 'xl', position: 'top' },
	    _react2.default.createElement(
	      _spacing2.default,
	      { type: 'padding', size: 'l', sizeM: '0', position: 'bottom' },
	      _react2.default.createElement(_HeadingBlock2.default, {
	        title: 'Handoff works with Sketch or designs created in Marvel',
	        justifyContent: 'center',
	        justifyM: 'center',
	        size: 'l',
	        copy: _react2.default.createElement(
	          'span',
	          null,
	          'No need to change the way you work, our UI handoff tool works seamlessly with the design tools you know and love - like Sketch.',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          'Our Sketch plugin makes it effortless for you to keep designs in sync with Marvel, and now Handoff takes care of taking your prototypes into the development stage. With Marvel you can accelerate your entire designer developer handoff process.'
	        )
	      })
	    ),
	    _react2.default.createElement(_MediaFeature2.default, _extends({}, _assets2.default.browser, {
	      pattern: false,
	      backgroundColor: color,
	      patternTop: '50%',
	      patternLeft: '35%'
	    }))
	  );
	}
	
	Design.propTypes = {
	  color: _propTypes2.default.string
	};
	module.exports = exports['default'];

/***/ }),

/***/ 661:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Sync;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _grid = __webpack_require__(5);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _HeadingBlock = __webpack_require__(13);
	
	var _HeadingBlock2 = _interopRequireDefault(_HeadingBlock);
	
	var _HandoffArtwork = __webpack_require__(464);
	
	var _HandoffArtwork2 = _interopRequireDefault(_HandoffArtwork);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Sync() {
	  return _react2.default.createElement(
	    _pageWrap2.default,
	    { size: 'l' },
	    _react2.default.createElement(
	      _spacing2.default,
	      { sizeM: 'xl', type: 'padding', position: 'topBottom' },
	      _react2.default.createElement(
	        _grid2.default,
	        { columns: 12, alignItems: 'center' },
	        _react2.default.createElement(
	          _grid.GridItem,
	          { columnSpan: 12, columnSpanM: 6 },
	          _react2.default.createElement(_HandoffArtwork2.default, null)
	        ),
	        _react2.default.createElement(
	          _grid.GridItem,
	          { columnSpan: 12, columnSpanM: 6 },
	          _react2.default.createElement(
	            _spacing2.default,
	            { sizeM: 'xl', type: 'padding', position: 'left' },
	            _react2.default.createElement(_HeadingBlock2.default, {
	              justifyContent: 'center',
	              justifyM: 'start',
	              maxWidth: 400,
	              title: 'Always in sync with the latest design changes',
	              copy: _react2.default.createElement(
	                'span',
	                null,
	                'With Marvel, all your work is updated in real time.',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                'Collaborator\'s design changes are synced automatically, so all the code, specs and assets generated in our UI handoff tool will always be the latest and correct version. No miscommunication, no madness.'
	              )
	            })
	          )
	        )
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 1274:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = FeatureHandoff;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactResponsive = __webpack_require__(18);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _metadata = __webpack_require__(22);
	
	var _metadata2 = _interopRequireDefault(_metadata);
	
	var _Page = __webpack_require__(16);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _HeroMedia = __webpack_require__(147);
	
	var _HeroMedia2 = _interopRequireDefault(_HeroMedia);
	
	var _Whitespace = __webpack_require__(35);
	
	var _Whitespace2 = _interopRequireDefault(_Whitespace);
	
	var _BorderTop = __webpack_require__(458);
	
	var _BorderTop2 = _interopRequireDefault(_BorderTop);
	
	var _Assets = __webpack_require__(657);
	
	var _Assets2 = _interopRequireDefault(_Assets);
	
	var _Code = __webpack_require__(658);
	
	var _Code2 = _interopRequireDefault(_Code);
	
	var _CtaBlock = __webpack_require__(659);
	
	var _CtaBlock2 = _interopRequireDefault(_CtaBlock);
	
	var _Design = __webpack_require__(660);
	
	var _Design2 = _interopRequireDefault(_Design);
	
	var _Sync = __webpack_require__(661);
	
	var _Sync2 = _interopRequireDefault(_Sync);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PAGE_COLOR = 'green';
	
	function FeatureHandoff() {
	  var handoff = _metadata2.default.features.handoff;
	
	  return _react2.default.createElement(
	    _Page2.default,
	    {
	      title: handoff.title,
	      meta: [{
	        name: 'description',
	        content: handoff.description
	      }, {
	        name: 'keywords',
	        content: handoff.keywords
	      }],
	      header: { isLight: true },
	      footer: true
	    },
	    _react2.default.createElement(_HeroMedia2.default, {
	      backgroundColor: PAGE_COLOR,
	      color: 'white',
	      tag: 'h1',
	      headline: 'Automatically create specs and design handoff for developers, saving your team hours of manual work',
	      headlineMaxWidth: 1000,
	      name: 'mkt_features_handoff',
	      type: 'video'
	    }),
	    _react2.default.createElement(_Whitespace2.default, null),
	    _react2.default.createElement(_Assets2.default, null),
	    _react2.default.createElement(_Sync2.default, { color: PAGE_COLOR }),
	    _react2.default.createElement(_Code2.default, { color: PAGE_COLOR }),
	    _react2.default.createElement(
	      _reactResponsive2.default,
	      { minWidth: 770 },
	      _react2.default.createElement(_Whitespace2.default, null)
	    ),
	    _react2.default.createElement(
	      _BorderTop2.default,
	      null,
	      _react2.default.createElement(_Design2.default, { color: PAGE_COLOR })
	    ),
	    _react2.default.createElement(_CtaBlock2.default, null)
	  );
	}
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-features-handoff-index-js-e991479b7dca465d965f.js